export default __webpack_public_path__ + "static/media/icon2.43bead2f.svg";